import React from "react";
import { mockFAQs } from "../mock";
import { MessageCircle, Mail } from "lucide-react";
import { Button } from "./ui/button";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

export const FAQSectionCRO = () => {
  return (
    <section id="faq" className="py-20 px-6 lg:px-8 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about the programmes
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4 mb-12">
          {mockFAQs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-gradient-to-br from-purple-50 to-white border-2 border-purple-100 rounded-xl px-6 hover:border-purple-300 transition-all duration-300"
            >
              <AccordionTrigger className="text-left text-gray-900 hover:text-purple-600 transition-colors duration-300 font-semibold">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Contact Section */}
        <div className="bg-gradient-to-r from-purple-50 to-indigo-50 border-2 border-purple-200 rounded-2xl p-8 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-4">
            Still have questions?
          </h3>
          <p className="text-gray-600 mb-6">
            We'd love to hear from you. Reach out to our team for more
            information.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={() =>
                window.open("https://wa.me/918591218023", "_blank")
              }
              className="bg-green-600 hover:bg-green-700 text-white"
            >
              <MessageCircle className="w-4 h-4 mr-2" />
              WhatsApp Us
            </Button>
            <Button
              variant="outline"
              onClick={() =>
                window.open(
                  "mailto:thefreebirdscollectiveindia@gmail.com",
                  "_blank"
                )
              }
              className="border-2 border-purple-600 text-purple-600 hover:bg-purple-50"
            >
              <Mail className="w-4 h-4 mr-2" />
              Email Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
